var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isShow)?_c('div',{staticClass:"go",on:{"click":_vm.goTop}},[_vm._v(" 顶部 ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }